import { getList } from "./utils/entity-network-requests"

const entityName = "knowledge-data"

export const getKnowledgeDataList = (token, parameters) =>
    getList(entityName, parameters, token)
